import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { Fields, reduxForm, getFormValues } from 'redux-form';

import Button from 'components/common/Button';
import MultiselectAutosuggestField from 'components/fields/MultiselectAutosuggestField';

import {
  requestFetchRoles,
  requestSearchRoles,
} from 'redux/modules/roles';
import { accountLoginFail } from 'redux/modules/account';

const styles = () => ({
  form: {
    width: 300,
    padding: '0 20px',
  },
  grid: {
    marginTop: 10,
    '&:first-child': {
      marginTop: 0,
    },
  },
});

function onChange(values, dispatch, props) {
  if (values['Selected Role']) {
    if (!values.Role
      || values.Role.findIndex(item =>
        item.value === values['Selected Role'].value) === -1) {
      props.array.push('Role', values['Selected Role']);
    }
    props.clearFields(false, false, 'Selected Role');
  }
}

const RolePermissionsCreateEditModelForm = ({
  handleSubmit,
  submit,
  change,
  classes,
  formValues,
  actions,
}) => {
  const selectedRolesID = formValues && formValues.Role
    ? formValues.Role.map(item => item.value)
    : [];
  return (
    <form
      className={classes.form}
      noValidate
      autoComplete="off"
      onSubmit={handleSubmit}
    >
      <Grid
        container
        spacing={24}
      >
        <Grid
          item
          xs={12}
        >
          <Fields
            id="Role"
            label="Role"
            names={[
              'Role Name',
              'Role',
            ]}
            autosuggestFieldName="Role Name"
            fieldArrayName="Role"
            placeholder="-Select Role-"
            errorPlacement="left"
            component={MultiselectAutosuggestField}
            renderSuggestionContent={suggestion => suggestion.Name}
            renderInputContent={suggestion => suggestion.Name}
            onSuggestionSelected={(suggestion) => {
              change('Selected Role', {
                value: suggestion.ID,
                label: suggestion.Name,
                accesses: suggestion.Accesses.map(item => item.ID),
              });
              return '';
            }}
            fetchSuggestions={({ value, limit, offset }) => (
              value.length > 0
                || selectedRolesID.length > 0
                ? requestSearchRoles({
                  filters: [
                    ...value.length > 0
                      ? [{
                        name: 'Name',
                        operation: 'startswith',
                        val: value,
                        case_sensitivity: false,
                      }] : [],
                    ...selectedRolesID.length > 0
                      ? selectedRolesID.map(item => ({
                        name: 'ID',
                        operation: 'ne',
                        val: item,
                      })) : [],
                  ],
                  limit,
                  offset,
                }).then(res => res.data,
                  (err) => {
                    if (err.data.error === 'Need authorisation') {
                      actions.accountLoginFail();
                    }
                    return err;
                  })
                : requestFetchRoles({
                  limit,
                  offset,
                }).then(res => res.data,
                  (err) => {
                    if (err.data.error === 'Need authorisation') {
                      actions.accountLoginFail();
                    }
                    return err;
                  })
            )}
            keepOpenAfterSelection
          />
        </Grid>
      </Grid>
      <Grid
        className={classes.grid}
        container
        justify="flex-end"
        spacing={24}
      >
        <Grid item>
          <Button
            className={classes.button}
            variant="raised"
            color="primary"
            onClick={() => {
              submit();
            }}
          >
            Submit
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

RolePermissionsCreateEditModelForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  actions: PropTypes.shape({
    accountLoginFail: PropTypes.func.isRequired,
  }).isRequired,
  formValues: PropTypes.shape({
    Role: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.number,
    })),
  }),
  classes: PropTypes.shape({
    form: PropTypes.string.isRequired,
    grid: PropTypes.string.isRequired,
  }).isRequired,
};

RolePermissionsCreateEditModelForm.defaultProps = {
  formValues: null,
};

const mapStateToProps = (store, ownProps) => {
  const formValues = getFormValues(ownProps.form)(store);
  return {
    formValues,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ accountLoginFail }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  onChange,
})(withStyles(styles)(RolePermissionsCreateEditModelForm)));



// WEBPACK FOOTER //
// ./src/components/settings/RolePermissionsCreateEditForm/RolePermissionsCreateEditModelForm.js